import { useIntl } from 'react-intl'

import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  nights: number
}

function CalendarPromotionLegend({ nights }: Props) {
  const intl = useIntl()

  return <BodyTextBlock variant="medium" startIcon={<SolidFireIcon colour="urgency" size="XS" />}>
    {intl.formatMessage({
      id: '5H4GxMJqDgfWU0zdSqUh',
      defaultMessage: 'Limited time special (min. {nights, plural, one {# night} other {# nights}})',
      description: 'Legend label for dates within the travel period of an active promotion (along with its minimum length of stay requirement)',
    }, { nights })}
  </BodyTextBlock>
}

export default CalendarPromotionLegend
